<template>
    <div class="flex w-full justify-center">
        <div class="w-2/3">
            <hts-form
                class="flex flex-col flex-1 overflow-hidden"
                :rules="rules">
                <hts-card class="pt-2">
                    <hts-form-select
                        v-model="formInput.type"
                        :label="$t('labels.type')"
                        :items="items" />
                    <hts-form-input
                        v-model="formInput.consumerId"
                        label="Consumer ID"
                        required />
                    <hts-form-input
                        v-model="formInput.apiKey"
                        label="API Key"
                        required />
                    <hts-form-input
                        v-model="formInput.username"
                        label="Username" />
                    <hts-form-input
                        v-model="formInput.password"
                        label="Password" />
                </hts-card>
                <div class="mt-2">
                    <hts-form-button
                        class="text-right"
                        color="main"
                        icon-name="hi-clipboard-document-check-icon"
                        icon-position="right"
                        type="submit"
                        @click="handleSubmit">
                        {{ $t('labels.save') }}
                    </hts-form-button>
                </div>
            </hts-form>
        </div>
    </div>
</template>

<script lang="ts" setup>
const formInput = ref<any>({
  type: 'eup',
  username: '',
  password: '',
  apiKey: '',
  consumerId: ''
})
const items = ref([{ label: 'EUP', value: 'eup' }])

const handleSubmit = () => {
  const api = $urlPartner.settings.updateGPSSettings
  $api(api, { body: formInput.value })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        process.client && $toast().success($t('notifications.updateSuccess'))
      }
    })
    .catch(() => {
      process.client && $toast().error($t('notifications.updateError'))
    })
}

const rules = {
  type: 'required',
  apiKey: 'required',
  consumerId: 'required'
}
const loading = ref(true)

onMounted(() => {
  _initData()
})

const _initData = () => {
  loading.value = true
  const api = $url.settings.getGPSSettings
  $api(api).then((data) => {
    loading.value = true
    if (!data) {
      return true
    }
    const responseData: any = data.data.value
    if (responseData.success) {
      Object.assign(formInput.value, { ...responseData.data })
      loading.value = false
    }
  })
}
</script>
